<template>
  <div>
    <div class="relevant-course-mall-wrapper">
      <div v-if="tableData.length > 0" class="course-mall">
        <div v-for="(item, key) in tableData" :key="key" class="course-mall-item" @click="viewDetail(item)">
          <div class="course-mall-content">
            <div class="course-mall-img-wrapper">
              <img :src="item.coverUrl" alt="" class="course-mall-img">
            </div>
            <div class="course-mall-info">
              <div class="course-mall-info-item">
                <div class="course-mall-title">{{ item.title }}</div>
              </div>
              <div class="course-mall-info-item">
                <div class="course-mall-value">
                  <span v-if="item.price == 0">免费</span>
                  <span v-else>￥{{ item.price }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="course-mall-btn animate" @click="viewDetail(item)">立即学习</div> -->
        </div>
        <div v-if="tableData.length > 0 && currentPage < totalPages" class="view-more-btn animate" @click="viewMore">
          查看更多
        </div>
      </div>
      <div v-else class="my-order-nodata-wrapper">
        <div class="my-order-nodata-img-wrapper">
          <img src="@/assets/img/noOrder.png" alt="" class="noorder-img">
        </div>
        <div class="my-order-nodata-info">暂无相关课程</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  recordCourseCategoryList,
  recordRelatedCourseList,
  joinCourseStudy
} from '@/api/index.js';
export default {
  props: {
    courseId: { // 课程id
      default: 0,
    }
  },
  name: '',
  components: {

  },
  data() {
    return {
      deptId: '',
      token: '',
      tableData: [],
      currentPage: 1,
      totalPages: 1,
    }
  },
  created() {
    //   this.deptId=this.$route.params.dept;
    //  this.token = window.localStorage.getItem('token');
    this.token = localStorage.getItem('token');
    this.dept = localStorage.getItem('dept');

  },
  mounted() {
    this.getRecordRelatedCourseList();
  },
  methods: {
    getRecordRelatedCourseList() {
      recordRelatedCourseList({
        "courseId": Number(this.courseId),
        "deptId": 0,
        "keyword": "",
        "pageNum": this.currentPage,
        "pageSize": 10,
        "userId": 0
      }, {
        Authorization: this.token,
        DeptId: this.deptId
      }).then(res => {
        if (res.code == 200) {
          this.totalPages = res.data.totalPages;
          var dataArr = this.tableData;
          this.tableData = dataArr.concat(res.data.list);
        }
        return;
      }).catch(err => {
        //   console.log(err);
      });
    },
    viewMore() {
      var currentPage = this.currentPage;
      if (currentPage < this.totalPages) {
        this.currentPage = currentPage + 1;
        this.getRecordRelatedCourseList();
      } else {
        this.$message({
          message: '没有更多了',
          type: 'warning'
        });
      }
    },
    viewDetail(row) {
      this.$router.push({ path: `/courseDetail/record-learn/${row.recordId}/${this.deptId}/${row.courseType}`, query: { isRelevantInto: true } });
      scrollTo(0, 0);
      location.reload()
    },
  },
}
</script>

<style scoped>
.relevant-course-mall-wrapper {
  margin-top: 18px;
  margin-bottom: 80px;
}

.relevant-course-mall-wrapper {
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #F0F0F3;
  margin-top: 18px;
}

.course-mall {
  padding: 28px 100px 88px 30px;
  min-height: 600px;
}

.course-mall-item {
  padding: 30px 0px 29px 0px;
  border-bottom: 1px solid #F0F0F0;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.course-mall-content {
  display: flex;
}

.course-mall-img-wrapper {
  width: 242px;
  margin-right: 30px;
}

.course-mall-img {
  width: 100%;
  height: 150px;
  border-radius: 8px;
}

.course-mall-info {
  flex: 1;
}

.course-mall-info-item {
  display: flex;
  margin-bottom: 12px;
}

.course-mall-label {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #606A74;
  margin-right: 34px;
}

.course-mall-title {
  width: 480px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.my-order-nodata-wrapper {
  text-align: center;
}

.course-mall-value {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff9645;
  margin-top: 86px;
}

.course-mall-btn {
  width: 108px;
  height: 44px;
  background: #3E63EE;
  border-radius: 6px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 23px;
}

.course-mall-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}

.view-more-btn {
  width: 122px;
  height: 34px;
  border-radius: 20px;
  border: 1px solid #F69264;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #F69568;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 50px;
}

.view-more-btn:hover {
  cursor: pointer;
  background: #F69264;
  color: #fff;
}
</style>


